export default {"src":"/_next/static/media/dottedPath.ef2d98e0.svg","height":371,"width":1278,"blurWidth":0,"blurHeight":0};